export default __webpack_public_path__ + "static/media/buku-besar.eb3452af.png";